module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "footer__container"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "footer__nav"
  }, [_c('router-link', {
    staticClass: "nav__link",
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("\n        À propos\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "nav__credits"
  }, [_vm._v("© RMN - Grand Palais")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer__rmn"
  }, [_c('a', {
    attrs: {
      "href": "http://www.grandpalais.fr/fr/evenement/jardins",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/img/logo_rmn.png",
      "alt": "Rmn"
    }
  })])])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-414a8c09!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UI/Footer.vue
 ** module id = 750
 ** module chunks = 2
 **/